import { FroalaEditorFunctionality } from './FroalaEditorFunctionality';
import * as React from 'react';

export class FroalaEditorButton extends FroalaEditorFunctionality {    
  render () {
    const that: any = this 
    return (        
      <button ref={el => that.el = el}>{this.props.children}</button>
    );
  }
}